import { UrlUtil } from "./Common/Http/UrlUtil";
export var BinaryUtil;
(function (BinaryUtil) {
    /**
     * サムネイルURLを作成
     * @param binary
     */
    function createThumbnailUrl(binary) {
        const paramMap = {};
        paramMap['id'] = binary.id;
        paramMap['unique_id'] = binary.unique_id;
        // paramMap['binary_id'] = binary.id;
        const thumbnailUrl = UrlUtil.createApiUrl('binary/thumbnail', paramMap);
        return thumbnailUrl;
    }
    BinaryUtil.createThumbnailUrl = createThumbnailUrl;
})(BinaryUtil || (BinaryUtil = {}));
